import { Dialog } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { ILieuFormationSelectorProps, LieuFormationSelector } from ".";
import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

const StyledDialog = styled(Dialog)`
  width: 1100px;
  height: auto;
  background-color: white;
`;

export interface ILieuFormationSelectorDialogProps extends ILieuFormationSelectorProps {
  onClosed: (selectedLieuFormationIds?: number[]) => void;
  selectorDialogOpen: boolean;
}

export const LieuFormationSelectorDialog: React.FunctionComponent<ILieuFormationSelectorDialogProps> = ({
  onClosed,
  selectorDialogOpen,
  ...otherProps
}) => {
  const { t } = useTl();

  return (
    <StyledDialog
      title={t(ETLCodes.SearchLieuFormations)}
      isOpen={selectorDialogOpen}
      enforceFocus={false}
      onClose={() => onClosed(null)}
    >
      <LieuFormationSelector {...otherProps} />
    </StyledDialog>
  );
};
